import { useEffect } from "react"

const OAuthRedirect = () => {
  useEffect(() => {
    // Send message to parent window
    window.opener.postMessage(
      {
        type: "oauth-success",
      },
      import.meta.env.VITE_APP_URL || "http://localhost:5174"
    )

    // Close this window
    window.close()
  }, [])

  return (
    <div>Authentication successful. This window will close automatically.</div>
  )
}

export default OAuthRedirect
